import { errorIdentityOf } from "@pandas/logger";
import type { ErrorComponentProps } from "@tanstack/react-router";
import { useEffect } from "react";
import logger from "@/lib/logging/logger";
import { staleChunkRecovery } from "@/lib/staleChunkRecovery";
import { ErrorFallbackContent } from "./ErrorFallbackContent";

/** Route errors land here rather than in ErrorBoundary: the router catches them first. */
export function RouteErrorFallback({ error }: ErrorComponentProps) {
	useEffect(() => {
		if (!staleChunkRecovery.maybeRecoverChunkCrash(error)) {
			// A nested Error serialises to {} in Axiom, so the row carries its identity instead.
			logger.error("INFO", "Unhandled route error", errorIdentityOf(error));
		}
	}, [error]);
	return <ErrorFallbackContent />;
}
